import { Sport } from '@sorare/core/src/__generated__/globalTypes';

import InventoryBoxesTypePage from 'pages/inventory/InventoryBoxesTypePage';

type Props = {
  sport: Sport;
  type: string;
};

export const BoxesTypePage = ({ sport, type }: Props) => {
  return (
    <InventoryBoxesTypePage sport={sport} type={type} withPageHeader={false} />
  );
};
